export class FileResponseDto {
    src: string;
    mimeType: string;
}